export default __webpack_public_path__ + "static/media/instagram.3c5c461f.png";